// let ENV = process.env

module.exports = {
  recruit_01: {
    header_00_text_01: '安心・安全がもたらす価値',
    header_01_text_01: '安心・安全がもたらす価値',
    header_01_text_02: '電解分解の必要性',
    card_01_text_01: '電解生成によりアルカリ水と酸性水の 2 種類の機能をもった水を生成できます。アルカリ水は洗浄に効果的で、逆に酸性水は殺菌に効果的です。水そのものが非常に物質を溶かしやすい液体ですが、油は溶かすことは困難です。油と水は分離してしまいます。',
    card_01_text_02: 'しかし洗剤を使用する目的が油汚れを落とす事が多いので、通常の洗剤の成分は油を溶解する成分【乳化成分】を使用しています。わかりやすく言うと表面張力を弱める成分、それが界面活性剤です。',
    card_01_text_03: '水と油が混ざり合わないので界面活性剤を使用しますが、界面活性剤には油やエタノールなど含まれています。水と油を混ぜることにより白濁して油分が残留してしまうので、必ずすすぎが必要になります。',
    card_01_text_04: 'そこで、すすぎの水を少なくする事や環境汚染などの事を配慮し、残留成分が少ないのであれば素材を痛めないのではないか、しかも洗浄対象の製品を劣化させないのではないか、清掃が短縮化され安全安心な洗剤があればなどなど…。',
    card_01_text_05: 'このように様々なテーマがありますが、こんな想いで開発する事になったのが加電水です。従来の水の洗浄能力を最大限に引き出し、特殊な電解生成により安定したアルカリ洗浄水を作ることになりました。',
    header_02_text_01: 'サイクル運転フローチャート',
    header_03_text_01: '加電水の生成方法',
    header_03_text_02: 'メンテナンス清掃の目的意識',
    card_02_text_01: 'メンテナンス清掃の目的意識',
    card_02_text_02: '環境衛生管理、美観維持、安全管理はすべてその企業価値（お客様のイメージ）向上につながります。建物に訪れるお客様や働く人々のために清潔で安全な環境を整えることで、',
    card_02_text_03: '大切な資産を守ると同時に、企業環境の清潔と安全を維持することが定期清掃（メンテナンス）の目的になります。',
    card_02_text_04: '',
    card_03_text_01: '加電水の生成方法',
    card_03_text_02: '従来、電解装置には電極の【＋】陽極と【−】陰極があり、陰極の方でアルカリ水、陽極の方で酸性の水ができます。',
    card_03_text_03: 'しかし、加電水生成装置では酸性水は作られない生成方法になります。洗浄水として必要なのは強アルカリ水ですので、アルカリ水だけを安定して生成できる仕組みになっています。',
    card_03_text_04: '水は電気分解だけによる電解水として強アルカリの数値で業界最高レベルの pH13.2 以上のアルカリ電解水を生成可能にしています。',
    card_04_text_01: '加電水の生成方法',
    card_04_text_02: '加電水は単純に水にアルカリ塩を加えてアルカリ水溶液を使用して電気分解を施し電解水と謳って販売している商品とは異なり、純水（H2O）を特殊電解した洗浄水となります。',
    card_04_text_03: 'その製造方法としましては生成装置ｐＨ13.0 の電解水を生成に必要な電解補助剤（炭酸カリウム）を 0.25%の添加量にて電解生成されます。',
    card_04_text_04: 'これを特殊な循環型荷電水方式にて２０L を生成するのに７０分間かけて電気分解しています。',
    card_04_text_05: '従来の洗剤成分である界面活性剤や水酸化ナトリウムに含まれるＯＨ-と、水から生まれた加電水のＯＨ-とでは性質が異なるようです。',
    card_05_text_01: '加電水の生成方法',
    card_05_text_02: '加電水 pH12.7〜pH１３を１Ｌ生成するのに必要な電解質の炭酸カリウムは 2.5g ちなみに１L にたいして重曹は約 9g また炭酸カリウム 18ｇでの水容液は約ｐＨ11.5 になりますつまりｐＨが高い、低いだけで危険度を判断できないのです。',
    card_05_text_03: 'ＰＨ１１でもイオン物資の含有量が多ければ刺激性は増す事になります。',
    card_05_text_04: 'ただし、イオン物質が多い方が品質保持期間（pH 値）は安定します。',
    card_05_text_05: 'もちろん中性洗剤のように油分やアルコール防腐剤などが添加されているものは品質（pH）が変化することなく安定しています。',
    footer_text_01: 'ホーム',
    footer_text_02: '安心・安全がもたらす価値'
  },
  recruit_02: {
    header_00_text_01: '電解アルカリ水 <br class="sp">【加電水】商品説明',
    header_01_text_01: '電解アルカリ水 <br class="sp">【加電水】商品説明',
    header_01_text_02: '電解分解の必要性',
    card_01_text_01: '電解生成によりアルカリ水と酸性水の 2 種類の機能をもった水を生成できます。アルカリ水は洗浄に効果的で、逆に酸性水は殺菌に効果的です。水そのものが非常に物質を溶かしやすい液体ですが、油は溶かすことは困難です。油と水は分離してしまいます。',
    card_01_text_02: 'しかし洗剤を使用する目的が油汚れを落とす事が多いので、通常の洗剤の成分は油を溶解する成分【乳化成分】を使用しています。わかりやすく言うと表面張力を弱める成分、それが界面活性剤です。',
    card_01_text_03: '水と油が混ざり合わないので界面活性剤を使用しますが、界面活性剤には油やエタノールなど含まれています。水と油を混ぜることにより白濁して油分が残留してしまうので、必ずすすぎが必要になります。',
    card_01_text_04: 'そこで、すすぎの水を少なくする事や環境汚染などの事を配慮し、残留成分が少ないのであれば素材を痛めないのではないか、しかも洗浄対象の製品を劣化させないのではないか、清掃が短縮化され安全安心な洗剤があればなどなど…。',
    card_01_text_05: 'このように様々なテーマがありますが、こんな想いで開発する事になったのが加電水です。従来の水の洗浄能力を最大限に引き出し、特殊な電解生成により安定したアルカリ洗浄水を作ることになりました。',
    header_02_text_01: '加電水の生成方法',
    header_02_text_02: '生成フロー',
    card_02_text_01: '生成フロー',
    card_02_text_02: '軟水装置で水処理を行います。水道水成分に含まれるカルシウム成分を除去する作業です。除去しないと電気分解するときに電極にカルシウムがどんどん付着します。付着すると安定した電気分解ができなくなるので、この作業が必要となります。',
    card_02_text_03: '活性炭フィルターとＰＰフィルターで塩素や不純物を取り除きます。',
    card_02_text_04: '純水装置で処理します。純水化するところまでが前処理になります。純水とは不純物を殆ど含まない純度の高い水で、他のイオン物資、塩類や有機物などは取り除かれています。すすぎ洗浄を軽減するには、残留物資が無いことが望ましいのです。',
    card_03_text_01: '洗浄のコツ',
    card_03_text_02: '使用方法で洗浄能力を向上させる事もできます。もちろん、薬品を添加しないで洗浄効果を上げる方法です。それは温度を上げることです。通常の水でも温度を上げることにより簡単に洗浄できる汚れもあります。',
    card_03_text_03: '例えば、鉄板でお好み焼きやもんじゃ作った後にこびりついた油汚れを洗浄するのに、鉄板が熱い状態で水をかけると、その熱湯で汚れが溶解して、簡単に油汚れが落ちるのを見たことがあると思います。',
    card_03_text_04: 'あれは、表面張力が減少して一時的に水と油が混ざり、汚れが落ちやすくなっているのです。表面張力を減少させることで洗浄ができるので、ｐＨ値の高い水を使って温度を上げれば、さらに高い洗浄効果を発揮します。',
    card_04_text_01: '加電水の洗浄特性 メリット',
    card_04_text_02: '二度拭きが必要ない（作業効率がいい）。',
    card_04_text_03: '人体に優しい。',
    card_04_text_04: '残留性が少ないので衛生的で美観維持に貢献。',
    card_04_text_05: '環境性に適している。',
    card_04_text_06: '油汚れに強い。',
    card_04_text_07: '品質が安定している。',
    card_04_text_08: '除菌、消臭効果。',
    card_05_text_01: '加電水の洗浄特性 デメリット',
    card_05_text_02: '浸け置き洗浄すると油分が浮いてくるので、汚れが再付着した場合すすぎが必要。',
    card_05_text_03: '泡が出ないので、壁などの汚れはすぐ垂れてくるので洗浄方法に工夫が必要。',
    card_05_text_04: 'アルミや真鍮・銅などはアルカリに反応しやすいので注意が必要（添加剤必要）',
    card_05_text_05: 'お風呂のカビなどには効果がありません。',
    footer_text_01: 'ホーム',
    footer_text_02: '電解アルカリ水【加電水】商品説明'
  }
}



// WEBPACK FOOTER //
// ./src/scripts/consts/i18n/jp.js